import { extractErrorMessage } from "../utility-function/ApiError";

export const DEBUG_MODE = false
export const ENDPOINT = 'https://api.cipra.ai:5000' // production server
// export const ENDPOINT = 'http://10.11.0.36:8001' // development server
// export const ENDPOINT = 'http://127.0.0.1:8000' //local server

export class RegistrationData {
    static instance: RegistrationData = new RegistrationData();

    // Returned from /validregistrationtoken
    pid: string = '';
    token: string = '';
    cell: string = '';
    email: string = '';

    // New account information that user fills out
    password: string = '';
    bloodPressureMedication: string = '';
    dmMedication: string = '';
    insulin: string = '';
    phoneType: 'Apple' | 'Android' | '' = '';
    deviceType: 'Apple Watch' | 'Fitbit' | 'No' | 'opt-out' | '' = '';
    address: string = '';
    addressCity: string = '';
    addressState: string = '';
    addressZipcode: string = '';

    // Provider-related metadata
    providerID: string = "";
    providerName: string = ""
    providerCountry: string = ""
    providerSupportEmail: string = "";
    providerSupportCell: string = "";

    // Display conditions for medication questions
    show_htn_med_question: boolean = false;
    show_dm_med_question: boolean = false;
    show_insulin_question: boolean = false;

    // Wearable device configuration
    show_wearable_device_question: boolean = false;
    provide_device_option: boolean = false;
    opt_out_wearable_option: boolean = false;

    getFullAddress(): string {
        const fullAddress = `${this.address}\n${this.addressCity}, ${this.addressState} ${this.addressZipcode}`
        return fullAddress === '\n,  ' ? '' : fullAddress
    }

    submit(callbackSuccess: () => void, callbackFail: (errorMessage?: string) => void): void {
        const submitData = {
            token: this.token,
            pid: this.pid,
            password: this.password,
            htn_med: this.bloodPressureMedication,
            dm_med: this.dmMedication,
            insulin: this.insulin,
            os: this.phoneType,
            device: this.deviceType,
            address: this.getFullAddress()
        }
        console.log("submitData:", submitData)

        fetch(`${ENDPOINT}/patient`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(submitData)
        })
            .then(async response => {
                console.log('Server Response:', response)
                if (response.ok) {
                    callbackSuccess()
                    return
                }
                const bodyText = await response.text().catch(() => '')
                callbackFail(extractErrorMessage(bodyText, response.status))
            })
            .catch(e => {
                console.log('Network Issue: ' + e)
                callbackFail()
            })
    }
}
